import { render, staticRenderFns } from "./IconAgenda.vue?vue&type=template&id=64a0123e&scoped=true"
import script from "./IconAgenda.vue?vue&type=script&lang=js"
export * from "./IconAgenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a0123e",
  null
  
)

export default component.exports